module.exports = __webpack_public_path__ + "img/aboutus-banner.4c9303e8.png";